export default {
  title: '404 - Page not found',
  heading: '404 - Page not found',
  text1: 'Unfortunately, such a page does not exist or has been deleted. ',
  text2: ' Go to Main page',
}